import { TranslocoService } from '@jsverse/transloco';

const TYPE_ALIASES: Record<string, string[]> = {
  hotel_5_stars: ['hotelsQuintupleStar', 'hotel5'],
  hotel_4_stars: ['hotelsQuadrupleStar', 'hotel4'],
  hotel_3_stars: ['hotelsTripleStar', 'hotel3'],
  hotel_2_stars: ['hotelsDoubleStar', 'hotel2'],
  hotel_1_star: ['hotelsStar', 'hotel1'],
  activity_motorized: ['motorized'],
  activity_cultural: ['cultural'],
  activity_sports: ['sports'],
  activity_nature: ['nature'],
  mainTransport: ['mainTransportImpact'],
  onSiteTransport: ['onSiteTransportImpact'],
  accommodation: ['accommodationImpact'],
  activity: ['activityImpact'],
  food: ['foodImpact'],
  waste: ['wasteImpact'],
};

const FALLBACK_NAMESPACES = [
  'impact.transportTypes',
  'impact.accommodationTypes',
  'impact.foodTypes',
  'impact.activityTypes',
  'impact.categories',
];

function translateIfAvailable(transloco: TranslocoService, key: string): string | null {
  const translated = transloco.translate(key);
  return translated === key ? null : translated;
}

export function translateElementType(transloco: TranslocoService, type: string): string {
  if (!type) {
    return type;
  }

  const candidates = [type, ...(TYPE_ALIASES[type] || [])];

  for (const candidate of candidates) {
    const translation = translateIfAvailable(transloco, `categoryType.${candidate}`);
    if (translation) {
      return translation;
    }
  }

  for (const namespace of FALLBACK_NAMESPACES) {
    for (const candidate of candidates) {
      const translation = translateIfAvailable(transloco, `${namespace}.${candidate}`);
      if (translation) {
        return translation;
      }
    }
  }

  return type;
}
